import axios from "axios";
import React, { useRef, useState } from "react";
import CssTransition from "./css-transition";

function Modal({
  id,
  open,
  title,
  description,
  onCancel,
  onApprove,
  cancelBtnText,
  okBtnText,
  modalOpen,
  setModalOpen,
  ...props
}) {
  const modalContent = useRef(null);
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white rounded-md shadow-lg overflow-auto max-w-lg w-full max-h-full"
        >
          <div class="p-5 flex space-x-4 ">
            <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-rose-100">
              <svg
                className={`w-4 h-4 shrink-0 fill-current ${ id === 'success-modal' ? 'text-green-500' : 'text-rose-500'}`}
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
              </svg>
            </div>
            <div>
              <div className="mb-2">
                <h4 className="text-lg font-semibold text-slate-800">
                  {title}
                </h4>
              </div>
              <div className="text-sm mb-10">
                <div className="space-y-2">
                  <p>
                    {/* Are you sure you want to delete your activity? All of your
                    data will be permanently removed from our servers forever.
                    This action cannot be undone. */}
                    {description}
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap justify-end space-x-2">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    onCancel();
                  }}
                  className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
                >
                  Cancel
                </button>
                {/* <button
                  onClick={DeleteUser}
                  className="btn-sm bg-rose-500 hover:bg-rose-600 text-white"
                >
                  Delete
                </button> */}
                {onCancel && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      onApprove();
                    }}
                    className="btn-sm bg-rose-500 hover:bg-rose-600 text-white"
                  >
                    {okBtnText}
                  </button>
                )}
              </div>
            </div>
            {/* <h3 class="mb-4 text-xl font-medium text-gray-900 dark:text-white flex justify-start">
              Delete activity
            </h3>
            <form class="space-y-6" action="#">
              <p className="text-gray-500 text-base ">
                Are you sure you want to delete your activity? All of your data
                will be permanently removed from our servers forever. This
                Action cannot be undone.
              </p>
              <div class="flex justify-end">
                <button
                  type="submit"
                  className=" text-white bg-blue-700 mr-3 bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white rounded-lg text-sm px-5 py-2.5 text-center flex justify-center"
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className=" text-white bg-blue-700 bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white rounded-lg text-sm px-5 py-2.5 text-center flex justify-center"
                  //class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  onClick={DeleteUser}
                >
                  Delete
                </button>
              </div>
            </form> */}
          </div>
        </div>
      </CssTransition>
    </>
  );
}

Modal.defaultProps = {
  title: "Warning",
  description:
    "This action cannot be undone, are you sure you want to perform this action?",
  cancelBtnText: "No",
  okBtnText: "Yes",
};
export default Modal;
